import { render, staticRenderFns } from "./Gauges.vue?vue&type=template&id=0374349a&scoped=true&"
import script from "./Gauges.vue?vue&type=script&lang=js&"
export * from "./Gauges.vue?vue&type=script&lang=js&"
import style0 from "./Gauges.vue?vue&type=style&index=0&id=0374349a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374349a",
  null
  
)

export default component.exports